import { Partial, Static, String as RTString, Undefined } from 'runtypes';
import { Address } from './address';

export const Custodian = Partial({
  custodianID: RTString,
  custodianName: RTString,
  custodianAddress: Address.Or(Undefined)
});

export type StaticCustodian = Static<typeof Custodian>;
